"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scale = exports.paddingBottom = exports.factor = void 0;
exports.factor = function (_a) {
    var width = _a.width, height = _a.height, dimensions = __rest(_a, ["width", "height"]);
    if ("maxHeight" in dimensions && !("maxWidth" in dimensions))
        return dimensions.maxHeight / height;
    if ("maxWidth" in dimensions && !("maxHeight" in dimensions))
        return dimensions.maxWidth / width;
    return Math.min(dimensions.maxWidth / width, dimensions.maxHeight / height);
};
exports.paddingBottom = function (_a) {
    var width = _a.width, height = _a.height;
    return (height / width) * 100.0 + "%";
};
exports.scale = function (_a) {
    var width = _a.width, height = _a.height, dimensions = __rest(_a, ["width", "height"]);
    var scale = exports.factor(__assign({ width: width, height: height }, dimensions));
    var scaledWidth = Math.floor(width * scale);
    var scaledHeight = Math.floor(height * scale);
    return {
        width: scaledWidth,
        height: scaledHeight,
        paddingBottom: exports.paddingBottom({ width: width, height: height }),
        scale: scale,
    };
};
//# sourceMappingURL=scale.js.map